import { AlertCircle } from "@/assets/Icons/AlertCircle";
import React, { ReactNode } from "react";
import { clsx } from "yet-another-react-lightbox";

type AlertType = "error" | "warning" | "info";

interface AlertProps {
  message: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  type?: AlertType;
  className?: string;
  noIcon?: boolean;
}

const Alert = ({
  message,
  description,
  icon,
  type = "info",
  className,
  noIcon,
}: AlertProps) => {
  return (
    <div
      className={clsx(
        "flex gap-2 border-2 rounded-md p-2 items-center w-full",
        type === "error" ? "border-error-400 bg-error-50" : "",
        type === "warning" ? "border-warning-400 bg-warning-50" : "",
        type === "info" ? "border-blue-400 bg-blue-50" : "",
        className
      )}
    >
      {!noIcon &&
        (icon ? icon : <AlertCircle className="shrink-0 w-10! h-10!" />)}
      <div className="flex flex-col gap-1">
        <span
          className={clsx(
            "text-text-sm font-semibold",
            type === "error" ? "text-error-500" : "",
            type === "warning" ? "text-warning-500" : "",
            type === "info" ? "text-blue-500" : ""
          )}
        >
          {message}
        </span>
        {description && (
          <span
            className={clsx(
              "text-text-sm",
              type === "error" ? "text-error-500" : "",
              type === "warning" ? "text-warning-500" : "",
              type === "info" ? "text-blue-500" : ""
            )}
          >
            {description}
          </span>
        )}
      </div>
    </div>
  );
};

export default Alert;
